import {
  FETCH_ORDERS,
  FETCH_LINE_ITEMS,
  FETCH_AD_DATA,
  CLEAR_AD_DATA,
} from "../actions/types";

export const adDataReducer = (state = [], action) => {
  switch (action.type) {
    case FETCH_ORDERS:
      return { type: "orders", data: action.payload };
    case FETCH_LINE_ITEMS:
      return { type: "lineItems", data: action.payload };
    case FETCH_AD_DATA:
      return { type: "adData", data: action.payload };
    case CLEAR_AD_DATA:
      return { type: "", data: [] };
    default:
      return state;
  }
};
